import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/authProvider';
import { ToastProvider } from './context/toastProvider';
import { registerLicense } from "@syncfusion/ej2-base";
import { initSentry } from './sentry';
import ErrorBoundary from './components/utils/errorBoundary';

initSentry();

registerLicense(process.env.REACT_APP_SYNC);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/*" element={<App/>}/>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </React.StrictMode>
  </ErrorBoundary>
);
